import Blue from "~/core";

new Blue({
  name: "rfp-table",
  selector: ".rfp, .table:not(.table--ignore)",
  setup(container) {
    const _prefix = container.getAttribute('class').includes('rfp') ? 'rfp' : 'table';
    const thead = container.querySelector(`.${_prefix}__head`);
    const tbody = container.querySelector(`.${_prefix}__body`);
    const headings = thead != null ? [...thead.querySelectorAll(`.${_prefix}__heading`)] : [];
    const rows = tbody != null ? [...tbody.querySelectorAll(`.${_prefix}__row`)] : [];
		const footCells = [...container.querySelectorAll("tfoot tr td")];

    const applyMobileHeadings = () => {
      rows.forEach(row => {
        let cells = [...row.querySelectorAll(`.${_prefix}__cell`)] || [];

        cells.forEach((cell, i) => {
          if (headings[i]) {
            cell.setAttribute("data-heading", headings[i]?.textContent);
          }
        });
      });
    };

    const bindSorting = () => {
      headings.forEach((heading, i) => {
        heading.addEventListener("click", () => {
          let sortType = heading.dataset.sort;
          
          headings.forEach(heading => heading.classList.remove(`${_prefix}__heading--sorted`));
          heading.classList.add(`${_prefix}__heading--sorted`);
          heading.dataset.dir = heading.dataset.dir === 'asc' ? 'dsc' : 'asc';

          if (sortType === "alpha") {
            rows.sort((row_a, row_b) => {
              let cell_a = [...row_a.querySelectorAll(`.${_prefix}__cell`)][i].textContent;
              let cell_b = [...row_b.querySelectorAll(`.${_prefix}__cell`)][i].textContent;
              let a = heading.dataset.dir === 'asc' ? cell_a : cell_b;
              let b = heading.dataset.dir === 'asc' ? cell_b : cell_a;
              
              if (a < b) return -1;
              if (a > b) return 1;
              return 0;
            });
          }

          else if (sortType === "numeric") {
            rows.sort((row_a, row_b) => {
              let cell_a = parseInt([...row_a.querySelectorAll(`.${_prefix}__cell`)][i].textContent);
              let cell_b = parseInt([...row_b.querySelectorAll(`.${_prefix}__cell`)][i].textContent);
              let a = heading.dataset.dir === 'asc' ? cell_a : cell_b;
              let b = heading.dataset.dir === 'asc' ? cell_b : cell_a;
              
              if (a < b) return -1;
              if (a > b) return 1;
              return 0;
            });
          }

          else if (sortType === "date") {
            rows.sort((row_a, row_b) => {
              let cell_a = new Date([...row_a.querySelectorAll(`.${_prefix}__cell`)][i].textContent);
              let cell_b = new Date([...row_b.querySelectorAll(`.${_prefix}__cell`)][i].textContent);
              let a = heading.dataset.dir === 'asc' ? cell_a : cell_b;
              let b = heading.dataset.dir === 'asc' ? cell_b : cell_a;
              
              if (a < b) return -1;
              if (a > b) return 1;

              return 0;
            });
          }

          rows.forEach(row => {
            row.__start = row.getBoundingClientRect().top;
          });
          rows.forEach(row => {
            tbody.insertAdjacentElement('beforeend', row);
          });
          rows.forEach(row => {
            row.__end = row.getBoundingClientRect().top;
          });
          rows.forEach(row => {
            row.animate([
              {transform: `translateY(${row.__start - row.__end}px)`},
              {transform: `translateY(0)`}
            ],
            {
              duration: 350,
              easing: 'ease'
            })
          })
        });
      });
    };

		footCells.forEach(td => td.setAttribute("colspan", headings.length));

    applyMobileHeadings();
    if (container.classList.contains(`${_prefix}--sortable`)) {
      bindSorting()
    };
  }
});